import PlainHtml, { PlainHtmlProps } from "./PlainHtml";

export { PlainHtml, PlainHtmlProps };

export default PlainHtml;
